import type {
  FandomTaxonomyCategoryKey,
  FandomTaxonomySchema,
  WindowFandomTaxonomy,
} from "../types";

export function getFandomTaxonomyCategory(
  category: FandomTaxonomyCategoryKey,
): FandomTaxonomySchema {
  const fandomTaxonomy = window?.fandomTaxonomy ?? ({} as WindowFandomTaxonomy);
  return fandomTaxonomy?.[category] ?? ([] as FandomTaxonomySchema);
}
